import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createAudience: {
    method: 'POST',
    url: `${configs.baseUrl}/api/audiences/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createAudience = async (payload) => {
  const res = await resource.createAudience(payload)
  return res.body
}

export default {
  initResource,
  createAudience,
}
